export default __webpack_public_path__ + "images/90e9fc16f6a0078fc4c27fa3e6d52130-sydney_mobile.webp";